import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ICartState, ITotalCartItems } from "./types";
import { IAcceptedNotice } from "../notices/types";

const initialState: ICartState = {
  totalCartItems: {},
  isLoading: false,
  fetchReserveStatus: "",
  basket: {},
  acceptedNotices: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartItems(state, action: PayloadAction<ITotalCartItems>) {
      state.totalCartItems = action.payload;
      state.basket = action.payload;
    },
    resetCartItems(state) {
      state.totalCartItems = {};
      state.basket = {};
    },
    setBasket(state, action: PayloadAction<ITotalCartItems>) {
      state.basket = action.payload;
      state.totalCartItems = action.payload;
    },
    clearBasket(state) {
      state.basket = {};
      state.totalCartItems = {};
      state.acceptedNotices = [];
    },
    setAcceptedNotices(state, action: PayloadAction<IAcceptedNotice[]>) {
      state.acceptedNotices = action.payload;
    },
  },
});

export const { setCartItems, resetCartItems, setBasket, clearBasket, setAcceptedNotices } =
  cartSlice.actions;

export default cartSlice.reducer;
